import {UPDATE_GROUP_POSTS_START} from "../../types";

export const update_group_posts = (payload) => ({
    type: UPDATE_GROUP_POSTS_START,
    payload,
});
